import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getUserProfile,
  getUserMBFProfile,
  loginAnonymous,
  getStats,
  userVote,
  checkVote,
  refreshToken,
  checkStatusCampaign,
} from "../apis";
import { STATUS_CAMPAIGN } from "../utilities/constants";
import { save, KEY } from "../cookie";

export const getProfileAsync = createAsyncThunk(
  "user/getProfileAsync",
  async (accessToken) => {
    let response = await getUserProfile(accessToken);
    let token = accessToken;
    // The value we return becomes the `fulfilled` action payload

    if (response?.response?.status === 426) {
      const freshTokenData = await refreshToken(accessToken);
      token = freshTokenData?.data?.access_token;
      if (token) {
        response = await getUserProfile(token);
      }
    }
    return { ...response.data, accessToken: token };
  }
);

export const getProfileMBFAsync = createAsyncThunk(
  "user/getProfileMBFAsync",
  async (accessToken) => {
    let response = await getUserMBFProfile(accessToken);

    // console.log(response);
    let token = accessToken;
    // The value we return becomes the `fulfilled` action payload

    if (response?.response?.status === 426) {
      const freshTokenData = await refreshToken(accessToken);
      token = freshTokenData?.data?.access_token;
      if (token) {
        response = await getUserMBFProfile(token);
      }
    }
    return { ...response.data, accessToken: token };
  }
);

export const getAnonymousAsync = createAsyncThunk(
  "user/getAnonymousAsync",
  async () => {
    const response = await loginAnonymous();
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const getListSingers = createAsyncThunk(
  "user/getListSingers",
  async () => {
    const response = await getStats();
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const checkCampaignStatus = createAsyncThunk(
  "user/checkCampaignStatus",
  async () => {
    const response = await checkStatusCampaign();
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const userVoting = createAsyncThunk(
  "user/userVoting",
  async ({ accessToken, objectId, forecastNo }) => {
    const response = await userVote({ accessToken, objectId, forecastNo });
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const checkVoteOfUser = createAsyncThunk(
  "user/checkVoteOfUser",
  async (accessToken) => {
    let response = await checkVote(accessToken);

    let token = accessToken;
    // The value we return becomes the `fulfilled` action payload
    if (response?.response?.status === 426) {
      const freshTokenData = await refreshToken(accessToken);

      token = freshTokenData?.data?.access_token;
      if (token) {
        response = await checkVote(token);
        save(KEY.ACCESS_TOKEN, token);
      }
    }
    return response.data;
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState: {
    profile: null,
    profileMBF: null,
    anonymous: null,
    listSingers: null,
    voteOfUser: 0,
  },
  reducers: {
    resetStatusUserVote: (state) => {
      state.userVoting = {};
    },
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(getProfileAsync.fulfilled, (state, action) => {
      // Add user to the state array
      state.profile = action?.payload || {};
    });
    builder.addCase(getProfileMBFAsync.fulfilled, (state, action) => {
      // Add user to the state array
      state.profileMBF = action?.payload || {};
    });
    builder.addCase(getAnonymousAsync.fulfilled, (state, action) => {
      // Add user to the state array
      state.anonymous = action?.payload || {};
    });
    builder.addCase(getListSingers.fulfilled, (state, action) => {
      // Add user to the state array
      state.listSingers =  action?.payload?.result.items || {};
    });
    builder.addCase(userVoting.fulfilled, (state, action) => {
      // Add user to the state array
      state.userVoting = action?.payload || {};
      state.voteOfUser = state.voteOfUser - 1;
      state.isLoadingVote = false;
    });
    builder.addCase(userVoting.pending, (state) => {
      // Add user to the state array
      state.isLoadingVote = true;
    });
    builder.addCase(userVoting.rejected, (state) => {
      // Add user to the state array
      state.isLoadingVote = false;
    });
    builder.addCase(checkVoteOfUser.fulfilled, (state, action) => {
      // Add user to the state array
      state.voteOfUser = action?.payload?.result?.count || 0;
    });
    builder.addCase(checkCampaignStatus.fulfilled, (state, action) => {
      // Add user to the state array
      const result = action?.payload?.result || {};
      const timeNow = Date.now();
      const startAt = new Date(result?.starts_at)
      const EndAt = new Date(result?.ends_at)
      let status = STATUS_CAMPAIGN.RUNNING;
      if (timeNow < startAt) {
        status = STATUS_CAMPAIGN.NOT_STARTED;
      }
      if (timeNow >= EndAt) {
        status = STATUS_CAMPAIGN.ENDED;
      }
      state.campaign = result;
      state.statusCampaign = status;
      state.campaignStartAt = result?.starts_at;
      state.campaignEndAt = result?.ends_at;
    });
  },
});

export const { resetStatusUserVote } = userSlice.actions;

export default userSlice.reducer;
